import { createAction, props } from '@ngrx/store';

export const locationSelected = createAction(
	'[Job Location] Job Location Selected',
	props<{ address: { lat: number; lon: number } }>()
);

export const pinDropped = createAction(
	'[Job Location] Pin Dropped',
	props<{ latlng: { latitude: number; longitude: number } }>()
);

export const jobLocationDestroyed = createAction(
	'[Job Location] Job Location Destroyed'
);
